/**
 * EmptyState — état vide du Bureau quand aucun master n'est sélectionné.
 *
 * Extrait de Bureau.jsx (Batch #14.221).
 */
import { Briefcase, FolderOpen, Calendar, FileText, StickyNote } from "lucide-react";

export default function EmptyState() {
  const ICONS = [FolderOpen, Calendar, FileText, StickyNote];
  const LABELS = ["Drive", "Calendar", "Docs", "Keep"];
  return (
    <div className="bg-white border-2 border-dashed border-slate-300 rounded-2xl p-12" data-testid="bureau-empty">
      <div className="text-center">
        <div className="w-16 h-16 rounded-2xl bg-slate-100 flex items-center justify-center mx-auto mb-4">
          <Briefcase className="w-8 h-8 text-slate-400" />
        </div>
        <h2 className="text-xl font-bold text-slate-700">Aucun dossier chargé</h2>
        <p className="text-sm text-slate-500 mt-1.5 max-w-md mx-auto">
          Sélectionnez un dossier client en haut de la page pour activer les outils Google Workspace.
        </p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mt-8 max-w-2xl mx-auto opacity-40">
        {ICONS.map((Icon, i) => (
          <div key={i} className="border border-slate-200 rounded-xl p-4 text-center">
            <Icon className="w-7 h-7 mx-auto mb-2 text-slate-400" />
            <div className="text-xs text-slate-500">{LABELS[i]}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
